import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { z } from "zod";

import RoundCheckbox from "@components/RoundCheckbox";

import { regex } from "@utils/zod";

type PasswordCriteriaType = (password: string) => Record<string, boolean>;
const passwordCriteria: PasswordCriteriaType = (password) => ({
  "8 characters": z
    .object({ password: z.string().min(8) })
    .safeParse({ password }).success,
  "One lowercase letter": z
    .object({ password: z.string().regex(/[a-z]/) })
    .safeParse({ password }).success,
  "One uppercase letter": z
    .object({ password: z.string().regex(/[A-Z]/) })
    .safeParse({ password }).success,
  "One number": z
    .object({ password: z.string().regex(/[0-9]/) })
    .safeParse({ password }).success,
  "One symbol": z
    .object({ password: z.string().regex(/[!#@$%^&*]/) })
    .safeParse({ password }).success,
});

const { email, password } = regex;
export const verificationCodeSchema = z.object({ email });
export const resetPasswordSchema = z
  .object({
    verificationCode: z
      .string()
      .length(4)
      .regex(/^[0-9]+$/),
    email,
    password,
    confirmPassword: password,
  })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: "custom",
        message: "The passwords do not match.",
        path: ["confirmPassword"],
      });
    }
  });

export type VerificationCodeFormValues = z.infer<typeof verificationCodeSchema>;
export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;

export const PasswordCriteria = (props: {
  password: string;
  showCriteria: boolean;
}) => {
  const { password, showCriteria } = props;
  const passwordValidation = passwordCriteria(password);

  return (
    <Fade in={showCriteria} unmountOnExit timeout={{ exit: 0 }}>
      <Paper elevation={3} square={false} sx={{ mb: 1 }}>
        <Typography sx={{ p: 1 }}>
          Password must contain:
          {Object.keys(passwordValidation).map((criteria) => {
            return (
              <p key={criteria}>
                <RoundCheckbox
                  disabled={true}
                  checked={passwordValidation[criteria]}
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    paddingTop: "5px",
                  }}
                />
                {criteria}
              </p>
            );
          })}
        </Typography>
      </Paper>
    </Fade>
  );
};

export default PasswordCriteria;
